import { Colors } from '../../colors';
import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const DotLine = ({ width = 18, height = 18, fill = Colors.gray900, ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="7.5" y="7.5" width="3" height="3" rx="1.5" fill={fill} />
    </Svg>
  );
};

export default DotLine;
